import React from 'react'

import { Skeleton } from '../../../../../ui/skeleton'

export const ClassesSkeleton = () => {
  return (
    <>
      <div className="rounded-xl border border-black/10 bg-white">
        <div className="flex items-center justify-between gap-3 border-b border-black/10 p-3 sm:p-7">
          <div>
            <Skeleton className="h-4 w-20 sm:w-24" />
            <div className="mt-1 flex flex-wrap gap-2">
              <Skeleton className="h-3.5 w-40 sm:w-56" />
            </div>
          </div>
          <Skeleton className="h-5 w-36 rounded-full" />
        </div>
        <div className="px-3 sm:px-7">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="border-t first:border-t-0 border-black/10 py-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <Skeleton className="h-4 w-32 sm:w-44" />
                    <Skeleton className="h-5 w-10 rounded-full" />
                  </div>
                  <div className="mt-2 space-y-1.5">
                    <Skeleton className="h-3.5 w-28 sm:w-32" />
                    <Skeleton className="h-3 w-56 sm:w-72" />
                    <Skeleton className="h-3 w-44 sm:w-60" />
                  </div>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-2">
                  <Skeleton className="h-5 w-5 rounded-md" />
                  <Skeleton className="h-3.5 w-28" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
